import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { TranslationHelperService } from './translations/translation-helper.service';
import { Observable, Subscription } from 'rxjs';
import { unsubscribe } from '../utils/helpers';

@Injectable({ providedIn: 'root' })
export class LanguageResolver  implements OnDestroy {
  subscriptions: Subscription[] = [];
  constructor(
    private translationHelperService: TranslationHelperService,
    private router: Router,
  ) {
    unsubscribe(this.subscriptions);
  }


  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const language = route.paramMap.get('language');

    if (this.translationHelperService.languages.indexOf(language) === -1) {
        // Use domain-based language for redirect when no language in URL
        const domainLocale = this.translationHelperService.getDomainBasedLocale();
        let defaultLanguage: string;

        if (domainLocale) {
            // Use domain-based language
            defaultLanguage = domainLocale.split('-')[0];
        } else {
            // Fallback to browser language
            const defaultLocale: string = this.translationHelperService.getDefaultLocale();
            defaultLanguage = defaultLocale.split('-')[0];
        }

        const newRoute = [defaultLanguage].concat([this.router.url]).join('');
        this.router.navigateByUrl(newRoute);
    } 

    this.translationHelperService.onRouteEvent(language);

    return language;
  }
  ngOnDestroy(): void {
    unsubscribe(this.subscriptions)
  }
}
